// extracted by mini-css-extract-plugin
export default {"body":"AdminNew_body__qj5G5"};